import PlaybackReviewTrigger from "packs/engines/subscriber_v2/playback_review_trigger";

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/subscriber_v2/serviceworker.js', { scope: '/subscriber_v2/' }).then(function (registration) {
    console.log('ServiceWorker registration successful with scope: ', registration.scope);

    window.addEventListener("supercast-timeupdate", function (event) {
      if (registration.active) {
        registration.active.postMessage({
          event: "supercast-timeupdate",
          detail: event.detail
        });
      }
    });
  }).catch(function (err) {
    console.log('ServiceWorker registration failed: ', err);
  });

  navigator.serviceWorker.addEventListener("message", function (event) {
    if (event.data.event === "supercast-episode-completed") {
      window.dispatchEvent(new CustomEvent("supercast:requestReview"));
    }
  });
} else {
  // run PlaybackReviewTrigger directly on the main thread instead
  const trigger = new PlaybackReviewTrigger();
  window.addEventListener("supercast-timeupdate", function (event) {
    trigger.onTimeUpdate(event.detail, function () {
      window.dispatchEvent(new CustomEvent("supercast:requestReview"));
    });
  });
}